export const tgidsWithSitesVisited = [28144, 3696, 26310];
